import {
  getSegregatedAddress,
  getCallLogId,
  isFFPromoCode,
} from '../common/common';
import { OrderStatus, SecQueOptions } from '../util/util';
import { getConfigs } from '../config';
import { Loader } from '../components/common/Loader';

const config = getConfigs();

export const getPersonalInfoModel = (
  fName,
  lName,
  callLogId,
  email,
  num,
  // billingAdd1,
  // billingAdd2,
  // billingCity,
  // billingState,
  // billingZip,
  // serviceAdd1,
  // serviceAdd2,
  // serviceCity,
  // serviceReference,
  // serviceState,
  // serviceZip,
  // addressIsSame,
  cellPhoneTermsAgreed,
  serviceCheckId,
) => {

  let orderInfoModel = {};
  // PERSONAL DETAILS
  orderInfoModel.firstName = fName;
  orderInfoModel.lastName = lName;
  orderInfoModel.email = email;
  orderInfoModel.phoneNum = num;
  // SERVICE ADDRESS DETAILS
  // orderInfoModel.serviceAddress = getAggregatedAddress({
  //   'address1': serviceAdd1,
  //   'address2': serviceAdd2,
  //   'city': serviceCity,
  //   'state': serviceState,
  //   'zipCode': serviceZip
  // });
  // orderInfoModel.serviceAdd1 = serviceAdd1;
  // orderInfoModel.serviceAdd2 = serviceAdd2;
  // orderInfoModel.serviceCity = serviceCity;
  // orderInfoModel.serviceState = serviceState;
  // orderInfoModel.serviceZip = serviceZip;
  // // BILLING ADDRESS DETAILS
  // if (addressIsSame) {
  //   orderInfoModel.billingAddress = getAggregatedAddress({
  //     'address1': serviceAdd1,
  //     'address2': serviceAdd2,
  //     'city': serviceCity,
  //     'state': serviceState,
  //     'zipCode': serviceZip
  //   });
  //   orderInfoModel.billingAdd1 = serviceAdd1;
  //   orderInfoModel.billingAdd2 = serviceAdd2;
  //   orderInfoModel.billingCity = serviceCity;
  //   orderInfoModel.billingState = serviceState;
  //   orderInfoModel.billingZip = serviceZip;
  // } else {
  //   orderInfoModel.billingAddress = getAggregatedAddress({
  //     'address1': billingAdd1,
  //     'address2': billingAdd2,
  //     'city': billingCity,
  //     'state': billingState,
  //     'zipCode': billingZip
  //   })
  //   orderInfoModel.billingAdd1 = billingAdd1;
  //   orderInfoModel.billingAdd2 = billingAdd2;
  //   orderInfoModel.billingCity = billingCity;
  //   orderInfoModel.billingState = billingState;
  //   orderInfoModel.billingZip = billingZip;
  // }
  orderInfoModel.orderStatus = OrderStatus.basicInfo;
  orderInfoModel.callLogId = callLogId;
  // orderInfoModel.serviceReference = serviceReference;
  orderInfoModel.cellPhoneTermsAgreed = cellPhoneTermsAgreed;
  orderInfoModel.serviceCheckId = serviceCheckId;
  return orderInfoModel;
}


export const getEnterInfoModel = (
  firstName,
  lastName,
  email,
  phoneNum,
  callLogId,
  serviceCheckId,
) => {
  let enterInfoModel = {
    firstName,
    lastName,
    email,
    phoneNum,
    callLogId,
    serviceCheckId,
    orderStatus: OrderStatus.basicInfo
  };
  return enterInfoModel;
};

export const getServiceAddressModel = (
  serviceAddress,
  serviceAdd1,
  serviceAdd2,
  serviceCity,
  serviceState,
  serviceZip
) => {
  let serviceAddressModel = {};
  serviceAddressModel.serviceAddress = serviceAddress;
  serviceAddressModel.serviceAdd1 = serviceAdd1;
  serviceAddressModel.serviceAdd2 = serviceAdd2;
  serviceAddressModel.serviceCity = serviceCity;
  serviceAddressModel.serviceState = serviceState;
  serviceAddressModel.serviceZip = serviceZip;
  return serviceAddressModel;
};

export const getCheckServiceableModel = (
  address,
  suggestedAddress,
  businessAddress,
  promoCode,
  affiliateID,
  businessPromoCode
) => {
  let checkServiceabilityModel = {};
  checkServiceabilityModel = {
    address,
    affiliateID: affiliateID,
    promoCode: businessAddress ? businessPromoCode : promoCode,
    partner: config.BUSINESS_PARTNER,
    keyFlags: 'extended_output',
  };
  if (suggestedAddress) {
    checkServiceabilityModel.suggestedAddress = suggestedAddress;
  }
  return checkServiceabilityModel;
};

export const getServiceCheckModel = (
  address,
  address1,
  address2,
  city,
  state,
  zip,
  agentId,
  productList,
  nbcScore
) => {
  let serviceCheckModel = {
    address,
    address1,
    address2,
    city,
    state,
    zip,
    agentId,
    productList,
    nbcScore,
  };
  return serviceCheckModel;
};

export const getAccountCheckModel = (firstName, lastName, accountEmail) => {
  let accountCheckModel = {
    firstName,
    lastName,
    accountEmail: accountEmail.split('@')[0],
    domain: accountEmail.split('@')[1] || 'earthlink.net',
  }
  return accountCheckModel;
};

export const serialize = (obj) => {
  let str = Object.keys(obj)
    .reduce(function (a, k) {
      a.push(k + '=' + encodeURIComponent(obj[k]));
      return a;
    }, [])
    .join('&');
  return str;
};

export const getOrderSubmissionModel = ({
  accountEmail,
  affiliateId,
  agentReadTC,
  answer,
  billingAddress,
  creditCardCSV,
  creditCardExp,
  creditCardNum,
  paymentType,
  abaNum,
  bankAccountNum,
  bankAccountType,
  customerAcceptedTC,
  email,
  firstName,
  lastName,
  orderId,
  password,
  phoneNum,
  promoCode,
  question,
  salesAgentId,
  serviceAddress,
  serviceReference,
  isExpressContainer,
  installWindow,
  isElnkMailboxReq,
  installPhone,
  bundleCode,
  spanishLanguagePref,
  source,
  serviceTerm,
  ffReferrerEmail,
  ffSiteToken,
  ffPromoCode,
  installType,
  isCsiEligible,
}) => {
  // const { question, answer } = getSecurityQuestion();
  const billingAddr = getSegregatedAddress(billingAddress);
  const isOptMail = isElnkMailboxReq && accountEmail && accountEmail.includes('@earthlink.net') ? true : isElnkMailboxReq;
  const createPrimary = isOptMail ? { accountEmail: accountEmail?.split('@')[0], domainName: accountEmail?.split('@')[1], } : { createPrimary: 'no' };
  const isCqasAdded = config.SHOW_PSWD_CQAS === 'true' ? {
    password,
    firstSecurityAnswer: answer,
    firstSecurityQuestion: question,
  } : {};
  const paymentFields = paymentType === 'bankDraft'
    ? {
      abaNum,
      bankAccountNum,
      bankAccountType,
      checkPay: false,
    }
    : {
      creditCardNum,
      creditCardExp,
      creditCardCSV,
    };
  let orderSubmissionModel = {};

  // Handed in from redux by the caller. The address feeds reward fulfillment and the token is
  // what a backend check would verify, so neither may come from anywhere a visitor can write.
  const ffReferrer = ffReferrerEmail || '';
  const isFFOrder = Boolean(ffSiteToken);
  // serviceReference is the cart's comma-joined servRef list, not a single ref - useCartData
  // appends the mobile ref and then each VAS ref to it - so it has to be matched per segment.
  // Comparing against the whole string meant the lookup failed on any cart with an add-on, and
  // a 5G order with a mobile line submitted FRIENDSFAMILY26 instead of FRIENDSFAMILY5G.
  //
  // The term's promo is load-bearing for Friends & Family only: a 5G selection must submit
  // FRIENDSFAMILY5G, which neither the caller nor session storage holds. Folding the FF gate
  // into the search rather than applying it after means a non-FF term can never win off any
  // segment, so an ordinary order's promo cannot change if /prequal ever echoes one back.
  // Segment order breaks a tie: the internet plan is always the first segment when present.
  //
  // Gated on there being a verified redemption at all, so a term-level promo can never reach
  // an order that is not a Friends & Family order, whatever /prequal happens to echo back.
  const segments = String(serviceReference ?? '').split(',').map((s) => s.trim()).filter(Boolean);
  const ffTermPromoCode = (isFFOrder && Array.isArray(serviceTerm))
    ? segments
      .map((segment) => serviceTerm.find((t) => String(t?.servServRef) === segment))
      .find((t) => isFFPromoCode(t?.promoCode))?.promoCode || null
    : null;
  // Then the caller, then the redemption's own promo - which is where the halo path has it,
  // since that flow never populates a session promo. Same policy as ServiceabilityCheck.
  //
  // Assigned rather than chained with `||` so an absent caller promo stays `undefined` and
  // JSON.stringify keeps dropping the key. Coercing it to null put an explicit `promoCode:
  // null` on ~100% of direct orders, which is a payload-shape change this ticket never asked
  // for and whose backend meaning is not ours to assume.
  let effectivePromoCode = promoCode;
  if (ffTermPromoCode) {
    effectivePromoCode = ffTermPromoCode;
  } else if (!promoCode && isFFOrder && isFFPromoCode(ffPromoCode)) {
    effectivePromoCode = ffPromoCode;
  }
  // serviceName is a BI tag, not an id: it must keep its 'elnkwww' default and its casing.
  // Lowercasing it shipped the live CR_REFERRAL tag as cr_referral, and defaulting it to the
  // affiliate id changed the value on ~100% of orders. A Friends & Family order sends this
  // default like any other: the order API reads serviceName as the client/user name, and FF
  // reporting runs off the promo code (Maxwell/Ann, ELNKWEB-2988). The caller stopped passing
  // FF_REFERRAL as `source` - this line stays a pass-through and has no FF branch.
  const optionalFields = {
    salesAgentId,
    serviceName: source || 'elnkwww',
    serviceReference,
    // siteToken travels so the backend can verify the referral is real before honouring FF
    // pricing. Nothing consumes it yet - see the ELNKWEB-2988 backend dependency.
    ...(ffReferrer ? { referringEmployeeEmail: ffReferrer, employeeEmail: ffReferrer } : {}),
    ...(ffSiteToken ? { siteToken: ffSiteToken } : {}),
  };
  const trackAttrs = ffReferrer ? { employeeEmail: ffReferrer } : null;

  if (isExpressContainer) {
    orderSubmissionModel = {
      affiliateId,
      broadbandOptionalFields: optionalFields,
      ...(trackAttrs ? { trackAttrs } : {}),
      billingAddress: {
        billingAddress1: billingAddr.address1,
        billingAddress2: billingAddr.address2,
        billingCity: billingAddr.city,
        billingState: billingAddr.state,
        billingZip: billingAddr.zip,
      },

      installPhone: installPhone ? installPhone : '',
      regInfo: {
        ...createPrimary,
        ...isCqasAdded,
        firstName,
        lastName,
        phoneNum,
        ...paymentFields,
        agentReadTC,
        customerAcceptedTC,
        languagePref: spanishLanguagePref ? 'spanish' : 'english',
      },
      email,
      orderId,
      promoCode: effectivePromoCode,
      isExpressContainer,
    }
  } else {
    const serviceAddr = getSegregatedAddress(serviceAddress);
    orderSubmissionModel = {
      callLogId: getCallLogId(),
      affiliateId,
      broadbandOptionalFields: optionalFields,
      ...(trackAttrs ? { trackAttrs } : {}),
      billingAddress: {
        billingAddress1: billingAddr.address1,
        billingAddress2: billingAddr.address2,
        billingCity: billingAddr.city,
        billingState: billingAddr.state,
        billingZip: billingAddr.zip,
      },

      installPhone: installPhone ? installPhone : '',
      regInfo: {
        ...createPrimary,
        ...isCqasAdded,
        firstName,
        lastName,
        serviceAddress1: serviceAddr.address1,
        serviceAddress2: serviceAddr.address2,
        serviceCity: serviceAddr.city,
        serviceState: serviceAddr.state,
        serviceZip: serviceAddr.zip,
        languagePref: spanishLanguagePref ? 'spanish' : 'english',
        phoneNum,
        ...paymentFields,
        agentReadTC,
        customerAcceptedTC,
        ...bundleCode,
      },
      installWindow: installWindow && installWindow.length > 0 ? installWindow : '',
      email,
      orderId,
      promoCode: effectivePromoCode,
      // ELNKWEB-2948: only present (and only true) for a CSI (address-contingent) Fiber plan
      // where the customer confirmed Self Install - matches affiliate-order-entry-web, the
      // other frontend on this same backend, which omits the key entirely otherwise rather
      // than sending `csiOrder: false`.
      ...(installType === 'self' && isCsiEligible && { csiOrder: true }),
    };
  }
  return orderSubmissionModel;
};

export const getCreateAccountInfoModel = (
  email,
  firstSecurityQuestion,
  firstSecurityAnswer,
  isElnkMailboxReq
) => {
  let createAccountInfoModel = {
    accountEmail: email.indexOf('@') === -1 ? `${email}@earthlink.net` : email,
    orderStatus: OrderStatus.acctEmail,
  };
  if (firstSecurityQuestion && firstSecurityAnswer) {
    createAccountInfoModel.firstSecurityQuestion = SecQueOptions[firstSecurityQuestion]
    createAccountInfoModel.firstSecurityAnswer = firstSecurityAnswer
  }
  if (!isElnkMailboxReq) {
    createAccountInfoModel.email = email;
  }
  return createAccountInfoModel;
};

export const getPaymentInfoModel = ({
  agentReadTC,
  customerAcceptedTC,
  maskedCcn,
  ccn,
  encryptedCcn,
  maskedCvc,
  cvc,
  encryptedCvc,
  cardHolderName,
  expirationDate,
  integrityCheck,
  paymentType
}) => {
  let paymentInfoModel = {
    agentReadTC,
    customerAcceptedTC,
    maskedCcn,
    ccn,
    encryptedCcn,
    maskedCvc,
    cvc,
    encryptedCvc,
    cardHolderName,
    expirationDate,
    integrityCheck,
    paymentType,
  };
  return paymentInfoModel;
};

export const getBankDraftPaymentInfoModel = ({
  agentReadTC,
  customerAcceptedTC,
  bankAccountType,
  maskedBankAccountNum,
  abaNum,
  bankAccountNum,
  paymentType,
}) => {
  return {
    agentReadTC,
    customerAcceptedTC,
    bankAccountType,
    maskedBankAccountNum,
    abaNum,
    bankAccountNum,
    paymentType,
  };
};

export const openReachMobileApp = async (
  emailId,
  fName,
  lName,
  billingAddress,
  shippingAddress,
  phoneNumber,
  callLogId,
  sessionId
) => {
  const billingAddr = getSegregatedAddress(billingAddress);
  const { address1, address2, city, state, zipCode } = billingAddr;
  const shippingAddr = getSegregatedAddress(shippingAddress);

  const payload = {
    emailId,
    zipcode: zipCode,
    firstName: fName,
    lastName: lName.length > 2 ? lName : fName,
    phoneNumber,
    addresses: [
      {
        address1,
        address2,
        city,
        country: 'US',
        name: [fName, lName].join(' '),
        state,
        type: 'billing',
        zip: zipCode,
      },
      {
        address1: shippingAddr.address1,
        address2: shippingAddr.address2,
        city: shippingAddr.city,
        country: 'US',
        name: [fName, lName].join(' '),
        state: shippingAddr.state,
        type: 'shipping',
        zip: shippingAddr.zipCode,
      },
    ],
    meta: {
      callLogId,
      sessionId,
    },
  };

  return fetch(`${config.REACH_ENDPOINT}/v0/subscriber`, {
    method: 'POST',
    redirect: 'follow',
    headers: {
      'content-type': 'application/json',
      'x-partner-id': `${config.REACH_PARTNER_ID}`,
      'x-api-key': `${config.REACH_API_KEY}`,
    },
    body: JSON.stringify(payload),
    mode: 'cors',
  }).then((response) => response.json());
};

export const getURI = (url) => {
  const [, ...segments] = url.replace(/http(s)?:\/\//gm, '').split('/');
  return `/${segments?.join('/').replace('//', '/')}`;
};

/* eslint-disable react/react-in-jsx-scope */
export const renderBroadbandFactsContent = (isBroadbandLabelLoading, isBroadbandLabelError, fccLabel) => {

  if (isBroadbandLabelLoading) {
    return <Loader />;
  } else if (isBroadbandLabelError) {
    return <span style={{ color: 'red' }}>{isBroadbandLabelError?.response?.data?.error}</span>;
  } else {
    return (
      <>
        <b>Broadband Facts</b> &nbsp;
        <i
          className="fas fa-external-link-alt"
          style={{
            color: '#007cba',
            cursor: !fccLabel?.serviceRef ? 'not-allowed' : 'pointer',
          }}
        />
      </>
    );
  }
}
/* eslint-enable react/react-in-jsx-scope */
